window.I18N = window.I18N || {};
window.I18N.cn = {
  common: {
    t001: '设置',
    t002: '外观设置',
    t003: '外观偏好',
    t004: '语言 · Language',
    t005: '浅色主题',
    t006: '深色主题',
    t007: '点缀色',
    t008: '字号大小',
    t009: '恢复默认',
    t010: '导览',
    t011: '联系',
    t012: '粤ICP备 2024xxxxxx 号',
    t013: '合格投资者专属',
    t014: '用户登录',
    t015: '访问基金月报、底层资产估值与投资人会议纪要。',
    t016: '账号',
    t017: '请输入投资人编号或邮箱',
    t018: '密码',
    t019: '登录',
    t020: '忘记密码',
    t021: '申请开通',
    t022: '登录 / 注册',
    t023: '深圳前海珂玺资本管理有限公司，专注半导体与硬科技的私募股权投资机构。',
    t024: '© 2016 – 2026 KEXI CAPITAL · 备案号 P1060401',
    t025: '微信',
    t026: '微博',
    t027: 'in',
    t028: 'Managing Partner',
  },
  main: {
    t001: 'EST. 2016 · 深圳前海',
    t002: '查看上市案例',
    t003: '· 业绩快照 · 2026 Q1',
    t004: '澜起科技解禁退出收益率',
    t005: '已上市 / 即将上市企业',
    t006: '家',
    t007: '管理基金支数',
    t008: '支',
    t009: '管理规模',
    t010: '亿',
    t011: '十年深耕，一线收获',
    t012: '珂玺资本成立于 2016 年，从深圳前海出发，专注半导体、人工智能、生物医疗与商业航天等核心领域。我们用一支支专项基金，沿着技术周期的关键节点做集中布局；用合伙人下场尽调的方式，与创始人共担创业风险与时间窗口。',
    t013: '/ 占位图 · 深圳前海天际线',
    t014: '管理人基本信息',
    t015: '成立于 2016 年 2 月，2016 年 12 月于中国证券投资基金业协会备案登记。登记编码 P1060401，是一家专业的私募股权基金管理机构。',
    t016: '了解珂玺资本',
    t017: '聚焦四条技术主线',
    t018: '我们不分散，不追风。深度押注半导体、AI 与智能驾驶、生物医疗、智能智造与商业航天 —— 国产替代周期内可被反复加注的硬科技底层。',
    t019: '查看投资策略',
    t020: '陪伴上市，时间作证',
    t021: '查看全部上市案例',
    t022: '全部投资组合',
    t023: '下一波即将兑现的窗口',
    t024: '我们怎样看待这件事',
    t025: '投资是一场关于时间的实验。在硬科技的语境里，最稀缺的不是判断，而是耐心。',
    t026: '合作 · COLLABORATE',
    t027: '携手布局',
    t028: '中美贸易、国产替代、技术周期切换 —— 半导体、智能硬件与生物医疗的下一个十年正在打开。无论您是合格投资者，还是寻求资本的创业者，我们都欢迎一次面对面的对话。',
    t029: '联系人 · CONTACT',
    t030: '电话 / 微信',
    t031: '地址',
    t032: '发送沟通邀请',
    t033: '关于珂玺资本',
    t034: '成立于技术周期的',
    t035: '转折之年',
    t036: '/ 占位 · 公司外景 / 深圳前海',
    t037: '公司概况',
    t038: '深圳前海珂玺资本管理有限公司成立于 2016 年 2 月，同年 12 月 9 日完成中国证券投资基金业协会备案登记，登记编码 P1060401，是一家专业的私募股权基金管理机构。',
    t039: '我们目前管理 15 支已备案基金（近 20 亿规模），其中 2 支盲池基金、13 支专项基金。商业航天专项基金（3 亿规模）、组合基金（2 亿规模）以及一支专项基金（1 亿规模）正在募集中。',
    t040: '成立时间',
    t041: '备案编码',
    t042: '基金支数',
    t043: '约 20 亿元',
    t044: '十年节奏',
    t045: '一支基金、一次决策、一个被时间证明的判断 —— 我们走过的每一年。',
    t046: '合伙人下场的尽调',
    t047: '我们没有研究员金字塔。每一笔投资从初次会面到投后管理都由合伙人主导 —— 这也是为什么我们的组合从不平庸。',
    t048: '/ 占位 · 团队肖像',
    t049: '我们相信，在硬科技的赛道上，真正的回报来自于「时间 × 浓度」。把时间投给少数对的人 —— 这就是珂玺的全部。',
    t050: '王 珍 · 管理合伙人',
    t051: '投资策略',
    t052: '在窄而深的赛道里',
    t053: '「专注」不是口号，是数字。十五支基金中超过九成的资金集中在四条主线 —— 这是我们能在每一次技术周期里复用同一套尽调框架的根本原因。',
    t054: '早期 · 中期阶段',
    t055: '侧重半导体、生物医疗、智能智造、人工智能、商业航天等核心领域。从天使到 B 轮，沿创始人技术路径连续加注。',
    t056: '后期 · Pre-IPO 阶段',
    t057: '主要围绕半导体行业，以及加投中早期已投的成长优质企业 —— 让确定性兑现成确定性。',
    t058: '聚焦的代价是有所不为',
    t059: '我们写下的四条原则',
    t060: '被「确定性」吸引',
    t061: '查看我们已上市的 7 家公司、Pre-IPO 储备与早期组合。',
    t062: '查看投资组合',
    num01: '01 / 公司简介',
    num02: '02 / 投资赛道',
    num03: '03 / 已上市案例',
    num04: '04 / Pre-IPO 储备',
    num05: '05 / 投资理念',
    num06: '01 / 发展历程',
    num07: '02 / 核心团队',
    num08: '01 / 四条主线',
    num09: '02 / 投资理念',
    kMilestones: 'MILESTONES',
    kTheTeam: 'THE TEAM',
    foundDate: '2016.02',
    regCode: 'P1060401',
    yearsCount: '15',
    kFirm: 'THE FIRM',
    kSectors: 'SECTORS',
    kListed: 'LISTED COMPANIES',
    kPipeline: 'PRE-IPO PIPELINE',
    kPhilosophy: 'PHILOSOPHY',
    heroL1: '耐心资本',
    heroL2a: '陪跑',
    heroL2b: '硬科技',
    num04b: '04 / Pre-IPO 储备',
    heroN1: '20',
    heroN2: '9',
    heroN3: '15',
    heroN4: '20',
    heroU1: '×',
    heroU2: '家',
    heroU3: '支',
    heroU4: '亿',
    statN1: '20',
    statN2: '15',
    statN3: '20',
    statN4: '7',
    statU1: 'x',
    statU2: '支',
    statU3: '亿',
    statU4: '+',
    secEx1: '澜起科技 / 思特威 / 慧智微 / 基本半导体 / 盾源聚芯',
    secEx2: '黑芝麻智能 / 佑驾创新 / 九章云极 / 蜻蜓智能',
    secEx3: '真迈生物 / 华源再生医学',
    secEx4: '快造科技 / 镭利电子 / 中天晶科',
    philoNum1: 'I.',
    philoNum2: 'II.',
    philoNum3: 'III.',
    philoNum4: 'IV.',
    brandNameCn: '深圳前海珂玺资本管理有限公司',
    brandNameEn: 'Shenzhen Qianhai Kexi Capital Management Co., Ltd.',
    collabL2: '制高点',
    philoSub1: 'Time over timing',
    philoSub2: 'Depth over breadth',
    philoSub3: "Build, don't extract",
    philoSub4: 'Anchored in localisation',
    secSub1: 'Semiconductors',
    secSub2: 'AI & Intelligent Driving',
    secSub3: 'Biotech & Life Sciences',
    secSub4: 'Smart Manufacturing & Aerospace',
    caseSub1: 'Montage Technology',
    caseSub2: 'SmartSens',
    caseSub3: 'Smarter Micro',
    case1_ticker: '688008', case1_year: '2019.07', case1_glyph: '澜起', case1_title: '澜起科技',
    case1_desc: '国际领先的数据处理及互连芯片设计公司，内存接口芯片全球三强之一，市场份额 45% 位列行业之首。',
    case1_market: '科创板', case1_ret: '20', case1_retLabel: '倍收益完美退出',
    case2_ticker: '688213', case2_year: '2022.05', case2_glyph: '思特威', case2_title: '思特威',
    case2_desc: 'CMOS 图像传感器先进供应商，覆盖安防监控、机器视觉、智能车载等场景。',
    case2_market: '科创板', case2_ret: '50', case2_retLabel: '%已解禁退出',
    case3_ticker: '688512', case3_year: '2023.05', case3_glyph: '慧智微', case3_title: '慧智微',
    case3_desc: '持续领先的 5G 射频前端方案供应商，全球首款可重构射频前端发明者。',
    case3_market: '科创板', case3_ret: '', case3_retLabel: '已上市',
    pipe1_year: '2025', pipe1_title: '基本半导体', pipe1_sector: '碳化硅 · SiC', pipe1_status: '境外上市备案已批',
    pipe2_year: '2026', pipe2_title: '奉加科技', pipe2_sector: '高性能混合信号 · Mixed-signal IC', pipe2_status: '拟提交港交所',
    pipe3_year: '2026', pipe3_title: '盾源聚芯', pipe3_sector: '硅熔接耗材 · Silicon consumables', pipe3_status: '拟申报创业板',
    pipe4_year: '2026', pipe4_title: '真迈生物', pipe4_sector: '基因测序 · Sequencing', pipe4_status: '已启动股改',
    pipe5_year: '2026', pipe5_title: '九章云极', pipe5_sector: 'AI 智算 · AI Infrastructure', pipe5_status: '拟提交港交所',
    t052b: '做长而集中的下注',
    stKickA: 'A / EARLY-TO-MID',
    stKickB: 'B / LATE-TO-PE',
    stFourKicker: 'THE FOUR TRACKS',
    stTagsA: '半导体 / 生物医疗 / 智能智造 / 人工智能 / 商业航天',
    stTagsB: '半导体加注 / 组合基金 / 专项基金 / 上市辅导',
    stTrack1Cn: '半导体', stTrack1Sub: 'Semiconductors', stTrack1Ex: '澜起科技 / 思特威 / 慧智微 / 基本半导体 / 盾源聚芯 / 矽睿科技',
    stTrack2Cn: '人工智能 & 智能驾驶', stTrack2Sub: 'AI & Intelligent Driving', stTrack2Ex: '黑芝麻智能 / 佑驾创新 / 九章云极 / 蜻蜓智能',
    stTrack3Cn: '生物医疗', stTrack3Sub: 'Biotech & Life Sciences', stTrack3Ex: '真迈生物 / 华源再生医学',
    stTrack4Cn: '智能智造 & 商业航天', stTrack4Sub: 'Smart Manufacturing & Aerospace', stTrack4Ex: '快造科技 / 镭利电子 / 中天晶科',
    stPhilo1Num: 'I.', stPhilo2Num: 'II.', stPhilo3Num: 'III.', stPhilo4Num: 'IV.',
  },
  portfolio: {
    t001: '投资组合',
    t002: '我们投过的',
    t003: '从澜起科技到基本半导体，从妃鱼直播到中天晶科 —— 一份按阶段呈现的完整组合。点击任意项目可查看详情。',
    t004: '已上市',
    t005: 'Pre-IPO 储备',
    t006: '早期典型项目',
    t007: '被投企业一览',
    t008: '一些可被你重复念起的名字 —— 它们构成了我们过去十年的全部叙事。',
    kLogoWall: 'LOGO WALL',
    t009: '已上市案例',
    t010: '时间作证的',
    t011: '4 家科创板、2 家港股、1 家曲线借壳 —— 这是我们过去十年「时间 × 浓度」最直接的注脚。',
    t012: '科创板 STAR Market',
    t013: '港交所 HKEX',
    t014: '曲线借壳上市',
    t015: '澜起科技退出回报',
    t016: '一笔一笔看',
    t017: '点击任意一家展开投资过程、退出节点与收益。',
    t018: '案例聚焦 · 澜起科技',
    t019: '一笔 20 倍的退出',
    t020: '澜起科技是全球仅有的三家内存接口芯片设计公司之一，市场份额 45% 位列行业之首。2018 年英特尔以 1.7 亿美元入股 10%，2019 年作为首批科创板公司挂牌上市，开盘当天突破千亿市值。',
    t021: '珂玺资本参投',
    t022: '英特尔战略入股',
    t023: '科创板上市',
    t024: '20× 退出',
    t025: '即将上市',
    t026: '家',
    t027: '投资过程',
    t028: '关键信息',
    t029: '股票代码',
    t030: '上市市场',
    t031: '上市时间',
    t032: '赛道',
    num01: '01 / 案例详情',
    num02: '02 / Logo 墙',
    casesReturn: '回报记录',
    casesStat1: '4', casesStat2: '2', casesStat3: '1', casesStat4: '20',
    kCaseByCase: 'CASE BY CASE',
    kThePipeline: 'PRE-IPO PIPELINE',
    casesWallTitle: 'Pre-IPO 储备',
  },
  aux: {
    t001: '新闻动态 · 行业洞察',
    t002: '我们看见的',
    t003: '投资动态、上市新闻、半导体与硬科技赛道的判断与笔记。',
    t004: '/ 封面 · 视涯科技上市',
    t005: '我们在 2021 年 B 轮与上海航空产投、小米产投同轮入局视涯，五年陪伴换来 2026 年 3 月的科创板挂牌。',
    t006: '阅读全文',
    t007: '编辑精选',
    t008: '联系我们',
    t009: '携手布局',
    t010: '无论您是合格投资者、创业者、行业研究者还是被投伙伴 —— 我们都欢迎一次面对面的对话。',
    t011: '地址 · 总部',
    t012: '联系人',
    t013: '电话 / 微信',
    t014: '微信号',
    t015: '邮箱',
    t016: '接待时间',
    t017: '发送沟通邀请',
    t018: '告诉我们您是谁、为何而来。',
    t019: '姓名',
    t020: '机构 / 公司',
    t021: '电话',
    t022: '身份',
    t023: '合格投资者 / LP',
    t024: '创业者 / 寻求投资',
    t025: '行业 / 研究合作',
    t026: '其他',
    t027: '您想沟通的内容',
    t028: '请简短说明 —— 我们会在 3 个工作日内回复。',
    t029: '发送',
    t030: '/ 地图 · 深圳前海 · 紫光信息港 B 座',
    t031: '深圳 · 南山 · 前海',
    t032: '招聘 · 加入我们',
    t033: '和我们一起',
    t034: '我们是一支精简、合伙人下场的团队 —— 没有研究员金字塔，每个人都参与决策、承担结果。',
    t035: '当前正在寻找',
    t036: '珂玺资本',
    t037: '地点',
    t038: '经验',
    t039: '类型',
    t040: '没看到合适的？',
    t041: '我们一直欢迎对硬科技投资有强烈兴趣的人 —— 把简历投到 hr@kexicapital.com。',
    t042: '已收到您的留言',
    t043: '我们会在 2 个工作日内通过邮件或电话与您联系。',
    t044: '再发一条',
    t045: '附件（选填）',
    t046: '点击选择文件 · 可多选（每个 ≤20MB，最多 10 个）',
    t047: '制高点',
    t048: '在高德地图打开 · 导航 →',
    t049: '做长期的事',
    t050: '深度决策',
    t051: '你将直接参与一线尽调与投决会，不做执行机器。',
    t052: '时间作单位',
    t053: '我们以「年」为单位思考 —— 不必为季度数据焦虑。',
    t054: '可被时间作证',
    t055: '你建立的判断会进入机构的知识储备，被长期复利。',
    t056: '01.',
    t057: '02.',
    t058: '03.',
    t059: '我们记下的',
    num01: '01 / 在招职位',
  },
  studio: {
    t001: '珂玺智库 · 研究服务',
    t002: '把资料交给我们',
    t003: '从资料到判断 · 四步交付',
    t004: 'AI 提取事实，研究员复核逻辑 —— 我们既不盲信 AI，也不放弃 AI 带来的效率。每一份报告都可以追溯到具体一行原文。',
    t005: '现在就开始',
    t006: '拖入文件或点击选择 —— 提交后您将进入审核队列。已通过资质审核的合格 LP 可在「我的报告」直接查看产出。',
    t007: '份资料',
    t008: '需要登录账号',
    t009: '合格用户登录后可查看历史报告与产出小站。',
    t010: '用户登录',
    t011: '· 示例预览',
    t012: '已公开的研究案例',
    t013: '下列报告与小站已由作者授权公开。点击任意一项可前往该案例的独立小站。',
    t014: '页',
    t015: '查看小站 →',
    t016: '准入说明',
    t017: '珂玺智库目前面向',
    t018: '合格 LP、被投企业创始人，以及与珂玺签订保密协议的合作机构。其他合作请通过 studio@kexicapital.com 联系。',
    t019: 'BP 通道 · 给创始人',
    t020: '把你的事业',
    t021: '一份表单，五分钟搞定。',
    t022: '填写以下信息并附上 BP（PDF / PPT，单文件 ≤ 30 MB）。如果你的项目与我们的赛道不匹配，我们也会推荐给可能感兴趣的同行机构。',
    t023: '我们关注的赛道',
    t024: '提交成功',
    t025: '我们已收到你的资料，合伙人将在 5 个工作日内通过邮件回复 —— 不论结果如何。',
    t026: '再提交一份',
    t027: '姓名 · 创始人',
    t028: '公司名称',
    t029: '邮箱',
    t030: '电话 / 微信',
    t031: '赛道',
    t032: '融资阶段',
    t033: '融资金额 · 估值',
    t034: '例: 5000 万人民币 · 估值 4 亿',
    t035: '一句话讲清你的事业',
    t036: '例: 国内唯一能量产 8 英寸 SiC 外延的公司',
    t037: '详细说明 · 选填',
    t038: '市场、团队、技术壁垒、当前进展...',
    t039: 'BP 附件 · PDF / PPT',
    t040: '点击或拖入 BP 文件',
    t041: '我已阅读并同意珂玺资本的保密承诺，本资料仅用于投资评估，珂玺将严格保密。',
    t042: '提交 BP',
    t043: '曾经的他们也是这样开始的',
    t044: '珂玺已陪伴上市的企业',
    t045: '讲给我们听',
    t046: '我们交回判断',
    k1: 'HOW IT WORKS',
    k2: 'SUBMIT MATERIALS',
    k3: 'PUBLIC SHOWCASE',
    step1: '第一步',
    step2: '第二步',
    step3: '第三步',
    step4: '第四步',
    member: 'MEMBERS',
    email: 'studio@kexicapital.com',
    regLogin: '注册 / 登录',
    regHint: '注册或登录后可上传资料、查看专属调研报告。',
    analyst: '调研员',
    num01: '01 / 工作流',
    num02: '02 / 提交资料',
    num03: '03 / 公开展示区',
    num04: '01 / 提交',
  },
};
